import { RulesSchema } from '@/rules';

export const botRules: RulesSchema = {
  attr: {
    botTTL: [(v: any) => !!v || 'Tempo máximo de espera obrigatório'],
    title: [(v: any) => !!v || 'Título obrigatório'],
    greetingsMessage: [(v: any) => !!v || 'Mensagem de boas vindas obrigatória'],
    defaultErrorMessage: [(v: any) => !!v || 'Mensagem de erro padrão obrigatória'],
  },
};

export const botPathRules: RulesSchema = {
  attr: {
    title: [(v: any) => !!v || 'Título obrigatório'],
    handlerType: [(v: any) => !!v || 'Ação obrigatória'],
  },
};

export const handlerConfigRules: RulesSchema = {
  attr: {
    teamId: [(v: any) => !!v || 'Time obrigatório'],
    userId: [(v: any) => !!v || 'Usuário obrigatório'],
    routingMessage: [(v: any) => !!v || 'Frase obrigatória'],
    url: [(v: any) => !!v || 'Url obrigatória'],
    fallbackTeam: [(v: any) => !!v || 'Time de contingência obrigatório'],
    actualPathId: [(v: any) => !!v || 'Caminho atual obrigatório'],
    selectedPathId: [(v: any) => !!v || 'Caminho selecionado obrigatório'],
  },
};

export const toStateRules: RulesSchema = {
  attr: {
    title: [(v: any) => !!v || 'Título obrigatório'],
  },
};
